export const IS_COMPANY_CHANGED = "IS_COMPANY_CHANGED";
